module.exports = __webpack_public_path__ + "img/popup-trai-tim-01-1000w.456432d1.jpg";